<template>
	<v-container fluid>
	<v-layout>
	  <v-flex xs12>
		 <v-dialog v-model="dialog" max-width="500px">
		  <v-card>
			<v-card-title>
			  <span class="headline">{{ request }} Organization {{actionType}} Request</span>
			</v-card-title>
			<v-card-text>
			  <v-container grid-list-md>
				<v-layout wrap>
				  <v-flex xs12 sm6 md6>
					<v-text-field
					 v-model="editedItem.organisationName"
					 label="Organization Name"
					 readonly
					 >
					 </v-text-field>
				  </v-flex>
				   <v-flex xs12 sm6 md6>
					<v-text-field
					 v-model="editedItem.organisationCode"
					 label="Organisation Code"
					 readonly
					 >
					 </v-text-field>
				   </v-flex>
				   <v-flex xs12 sm6 md6>
					 <v-text-field
					 v-model="editedItem.dateOfIncorporation"
					 label="Date Of Incorporation"
					 readonly
					 >
					 </v-text-field>
				   </v-flex>
				  <v-flex xs12 sm6 md6>
					<v-text-field
					 v-model="editedItem.address"
					 label="Address"
					 readonly
					 >
					</v-text-field>
				  </v-flex>
				  <v-flex xs12 sm6 md6>
					<v-text-field
					 v-model="editedItem.postalCode"
					 label="Postal Code"
					 readonly
					 >
					</v-text-field>
				  </v-flex>
				</v-layout>
			  </v-container>
			</v-card-text>
			<v-card-actions>
			  <v-spacer></v-spacer>
			  <v-btn color="secondary" @click.native="close">Cancel</v-btn>
			  <v-btn color="primary" @click.native="save">Submit</v-btn>
			</v-card-actions>
		  </v-card>
		</v-dialog>
      <v-card>
        <v-card-text>
      <v-layout row pr-1 mr-1 pb-1 mb-1>
        <v-spacer></v-spacer>
        <v-flex xs3>
          <v-text-field v-model="searchQuery" append-icon="search" label="Search"  @input="handleSearchInput"
                        single-line hide-details color="primary"></v-text-field>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="organizations"
        class="elevation-1"
        :search="searchQuery"
        :options.sync="pagination"
        :items-per-page="itemsPerPage"
        :loading="viewloading"  hide-default-footer
      >
		<template v-slot:[`item.dateCreated`]="{ item }">
			{{item.dateCreated | prettyDateTime }}
		</template>
		<template v-slot:[`item.dateUpdated`]="{ item }">
			{{item.dateUpdated | prettyDateTime }}
		</template>
		<template v-slot:[`item.actions`]="{ item }">
			<v-menu offset-y>
			  <template v-slot:activator="{ on }">
				<v-btn
				color="primary"
				v-on="on"
				text
				icon
				class="actions"
			  >
				<v-icon> more_horiz </v-icon>
			  </v-btn>
			  </template>
			  <v-list>
				<v-list-item @click="approveItem(item)" v-if="canApproveOrg">
				  <v-list-item-title> Approve </v-list-item-title>
				</v-list-item>
				<v-list-item @click="declineItem(item)" v-if="canApproveOrg">
				  <v-list-item-title> Decline </v-list-item-title>
				</v-list-item>
			  </v-list>
			</v-menu>
		 </template>
	   </v-data-table>
        </v-card-text>
      <v-card-actions>
            <span class="paginationtext">
              Showing {{ page }} of {{ numberOfLinks }} pages
            </span>
        <v-spacer></v-spacer>
        <v-pagination
          v-model="page"
          :length="numberOfLinks"
          :total-visible="7"
          color="secondary"
                class="accent--text logoutbtn"
        ></v-pagination>
      </v-card-actions>
      </v-card>
	  </v-flex>
	</v-layout>
	</v-container>
	</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import moment from 'moment';

export default {
	name: 'vieworganization',
	data: function () {
		return {
			headers: [
				// { text: 'Name', value: 'organisationName' },
				// { text: 'Org Code', value: 'organisationCode' },
				{ text: 'Audit ID', value: 'auditId' },
				{ text: 'Created By', value: 'createdBy' },
				// { text: 'Updated By', value: 'createdBy' },
				{ text: 'Created At', value: 'dateCreated' },
				// { text: 'Created At', value: 'dateUpdated' },
				{ text: 'Changed Fields', value: 'changedFields' },
				{ text: 'Request Type', value: 'actionType' },
				{ text: 'Old Value', value: 'oldValue' },
				{ text: 'New Value', value: 'newValue' },
				// { text: 'Actions', value: 'actions', sortable: false }
			],
			organizations: [],
			message: '',
			error: '',
			loading: true,
			page: 1,
			currentPage: 0,
			searchQuery: '',
			numberOfLinks: 0,
			numberOfItemsPerPage: window.innerHeight <= 600 ? 6 : window.innerHeight > 600 && window.innerHeight <= 1000 ? 14 : 20,
			pagination: {},
			viewloading: false,
			totalOrganizations: 0,
			snackbar: false,
			snackbarColor: '',
			editedIndex: -1,
			permissions: [],
			defaultItem: {
				id: '',
				organizationName: '',
				organisationCode: '',
				dateOfIncorporation: '',
				address: '',
				postalCode: '',
				makerUsername: ''
			},
			editedItem: {
				id: '',
				organizationName: '',
				organisationCode: '',
				dateOfIncorporation: '',
				address: '',
				postalCode: '',
				makerUsername: ''
			},
			dialog: false,
			request: '',
			messsage: '',
			actionType:''
		}
	},
	mounted () {
		this.getOrganizationsToBeApproved(this.currentPage)
		this.permissions = store.state.user.roleId.permissions
	},
	watch: {
		organizations: function () {
			this.paginatedItems = this.organizations
		},
		page: function (val) {
			this.paginatedItems = this.getOrganizationsToBeApproved(val - 1)
		}
	},
	filters: {
    prettyDateTime(value) {
      if (!value) return '';
      return moment(value).format('DD MMM YYYY, HH:mm:ss'); // Customize as needed
    }
  },
	computed: {
		itemsPerPage: {
			get () {
				return this.pagination.itemsPerPage
			},
			set (value) {
				this.pagination.itemsPerPage = value
			}
		},
		canCreateOrg () {
			if (this.hasPerm('CAN_CREATE_ORGANISATION')) {
				return true
			} else {
				return false
			}
		},
		canViewOrg () {
			if (
				this.hasPerm('CAN_VIEW_ORGANISATION') ||
			this.hasPerm('CAN_UPDATE_ORGANISATION')
			) {
				return true
			} else {
				return false
			}
		},
		canApproveOrg () {
			if (this.hasPerm('CAN_APPROVE_ORGANISATION')) {
				return true
			} else {
				return false
			}
		}
	},
	methods: {
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		approveItem (item) {
			this.editedIndex = this.organizations.indexOf(item)
			this.editedItem = Object.assign({}, item)
			this.dialog = true
			this.request = 'Approve'
			this.actionType=item.actionType
			this.editedItem.approvalStatus = 'approved'
		},
		declineItem (item) {
			this.editedIndex = this.organizations.indexOf(item)
			this.editedItem = Object.assign({}, item)
			this.dialog = true
			this.request = 'Decline'
			this.actionType=item.actionType
			this.editedItem.approvalStatus = 'declined'
		},
    handleSearchInput(){
      this.getOrganizationsToBeApproved(this.currentPage)
    },
		close () {
			this.dialog = false
			setTimeout(() => {
				this.editedItem = Object.assign({}, this.defaultItem)
				this.editedIndex = -1
			}, 300)
		},
		save () {
			if (this.editedItem.approvalStatus === 'approved') {
				this.sendRequest('approve')
			} else if (this.editedItem.approvalStatus === 'declined') {
				this.sendRequest('decline')
			}
			this.close()
		},
		sendRequest (request) {
			var url = config.serverURI + '/organization/update/' + request
			axios.post(url, this.editedItem)
				.then(response => {
					this.snackbar = true
					if (response.data.error) {
						this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message })
					} else {
						this.organizations = this.getOrganizationsToBeApproved(this.currentPage)
						this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
					}
				})
				.catch(error => {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
				})
		},
		getOrganizationsToBeApproved (page) {
			console.log('getOrganizationsToBeApproved')
			// var url = config.serverURI + '/organization/approvalrequests?page=' + page + '&size=' + this.numberOfItemsPerPage + '&query=' + this.searchQuery
            var url = config.serverURI + '/organization/getAllAudit?&page=' + page + '&size=' + this.numberOfItemsPerPage + '&query=' + this.searchQuery;

			this.loading = true
      this.viewloading = true
			axios.get(url)
				.then(response => {
					console.log('one')
					console.log('two - ', response)
					this.loading = false
          this.viewloading = false
					if (response.status !== 200) {
						console.log('three - ')
						this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message })
						return
					}
					console.log('four - ')
					console.log('four4 - ', response.data)
					console.log('four44 - ', response.data.content)
					// this.organizations = response.data.content
					this.organizations = response.data.content
					this.numberOfLinks = response.data.page.totalPages
					this.numberOfItemsPerPage = response.data.page.size
					this.currentPage = response.data.page.number
					console.log('five - ', this.organizations)
				})
				.catch(error => {
          this.viewloading = false
					console.log('five - ')
					console.log('six - ', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
				})
			console.log('seven - ')
			return this.organizations
		}
	}
}

</script>
	<style>
	</style>
